module.exports = __webpack_public_path__ + "static/media/multi-image-2-mobile.86bc94f7.png";